module.exports = __webpack_public_path__ + "img/18_Middle-rectrum.a9f890b9.png";